<template>
  <Select
    class="documents-list__select"
    :placeholder="placeholder"
    :value="selectedDocumentId"
    :options="filteredDocumentTypes"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="name"
    :disabled="isDisabled"
    :select-first-by-default="false"
    :error-messages="errorMessages"
    @beforeChange="onBeforeChange"
    @change="handleDocumentSelect"
  >
    <template #option="{ option }">
      <p v-if="option" class="documents-list-option__info-text">
        {{ option.name }}
      </p>
    </template>
  </Select>
</template>

<script>
import { commonDocumentTypes, documentTypes } from '@/features/selectors';
import { Select } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть тип документа',
    },
    allowedDocumentTypes: {
      type: Array,
      default: () => null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    selectSingleDocument: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedDocumentId: null,
    };
  },
  computed: {
    allDocumentTypes() {
      return documentTypes;
    },
    defaultDocumentTypes() {
      return commonDocumentTypes;
    },
    filteredDocumentTypes() {
      if (this.allowedDocumentTypes && this.allowedDocumentTypes.length > 0) {
        const allowedIds = this.allowedDocumentTypes.map(item =>
          typeof item === 'object' ? item.id : item
        );
        return this.allDocumentTypes.filter(doc =>
          allowedIds.includes(doc.id)
        );
      }

      return this.defaultDocumentTypes;
    },
  },
  mounted() {
    if (this.selectSingleDocument && this.filteredDocumentTypes?.length === 1 && !this.value) {
      this.handleDocumentSelect(this.filteredDocumentTypes[0]?.id);
    }
  },
  components: { Select },
  methods: {
    handleDocumentSelect(selectedId) {
      const selectedDocument = this.filteredDocumentTypes.find(doc => doc.id === selectedId);
      this.selectedDocumentId = selectedDocument ? selectedDocument.id : null;
      this.$emit('input', selectedDocument || null);
      this.$emit('change', selectedDocument || null);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const newId = typeof newValue === 'object' ? newValue.id : newValue;
          if (this.selectedDocumentId !== newId) {
            this.selectedDocumentId = newId;
          }
        }
      },
    },
    filteredDocumentTypes: {
      handler() {
        if (
          this.selectSingleDocument
          && this.filteredDocumentTypes?.length === 1
          && this.selectedDocumentId !== this.filteredDocumentTypes[0]?.id
          && !this.value
        ) {
          this.handleDocumentSelect(this.filteredDocumentTypes[0]?.id);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.documents-list__select {
  width: 100%;
}

.documents-list-option__info-text {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }
}
</style>
